/*eslint-disable */
import React, { useState } from "react";

// Custom Components
import Table from "@Components/Table";
import Filter from "components/Filter";
import withSelect from "../withSelect";
import { URLS } from "configs/constants";

let model = [
  { id: "name", label: "Name", type: "string" },
  { id: "status_label", label: "Status", type: "string" },
];

const actions = ["edit"];

const filterInitialValues = {
  name: "",
  active: null,
};

const IDTypeList = () => {
  const [filterValues, setFilterValues] = useState({});
  const filterFields = [
    {
      type: "input",
      label: "Name",
      name: "name",
    },
    {
      type: "reactselect",
      name: "active",
      label: "Status",
      outerOptions: [
        { id: "1", name: "ACTIVE" },
        { id: "0", name: "INACTIVE" },
      ],
    },
  ];

  const onFilterRequest = (values) => {
    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };

  return (
    <div>
      {/* FIXME: 10953 - Filter hidden for now */}
      <div style={{ margin: '5px' }}>

      <Filter
        initialValues={filterInitialValues}
        filterFields={filterFields}
        onSubmit={onFilterRequest}
      />
      </div>
      <Table
        proxyURL="idcard/bo-list/"
        model={model}
        actions={actions}
        filterValues={filterValues}
        noFilter
      />
    </div>
  );
};

export default withSelect(IDTypeList, URLS.ID_TYPE_CUSTOM_FIELDS);
